import React, { useContext, useState } from "react";
import Form from "../../components/Form/Form";
import QuizArea from "../QuizArea/QuizArea";
import quizContext from "../../context/quizContext";
import { HashLoader } from "react-spinners";
import { Text } from "@chakra-ui/react";

const Home = () => {
  const context = useContext(quizContext);
  const { setUrl, url, fetchQuestions, setLoading, loading, questions } =
    context;
  const [formData, setFormData] = useState({
    number: "",
    category: "",
    difficulty: "",
    type: "",
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    const { number, category, difficulty, type } = formData;
    setUrl(
      `https://opentdb.com/api.php?amount=${number}&category=${category}&difficulty=${difficulty}&type=${type}`,
      fetchQuestions(url)
    );
    setLoading(true);
  };

  const onChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  return (
    <>
      <div className="d-flex justify-content-center align-items-center">
        <HashLoader
          color={"#20bf6b"}
          loading={loading}
          size={100}
          aria-label="Loading Spinner"
          data-testid="loader"
          style={{
            backgroundColor: "#4d4d4dcc",
            width: "100%",
            height: "100vh",
            position: "absolute",
            top: "13%",
          }}
        />
      </div>
      {url === "" || questions.length === 0 ? (
        <div className="container my-3">
          <Text mb={"4"} fontSize="4xl" fontWeight={"bold"} color={"#20bf6b"}>
            Start your Quiz Now
          </Text>
          <hr style={{ borderWidth: "2px" }} />
          <Form handleSubmit={handleSubmit} onChange={onChange} />
        </div>
      ) : (
        <QuizArea />
      )}
    </>
  );
};

export default Home;
